import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { catchError, finalize } from "rxjs/operators";
import { HelperService } from "../../../../services/helper.service";
import { BehaviorSubject } from "rxjs";
import { LoadingScreenService } from "../../common/LoadingScreen/LoadingScreen.service";

@Injectable({
	providedIn: "root",
})
export class UploadFileApkIpaService {
	public uploadInProgress$ = new BehaviorSubject<boolean>(false);

	constructor(
		private helperService: HelperService,
		private httpClient: HttpClient,
		private loadingScreenService: LoadingScreenService
	) {}

	getUploadStatus() {
		return this.uploadInProgress$.asObservable();
	}

	isUploading(): boolean {
		return this.uploadInProgress$.getValue();
	}

	private handleError(error) {
		// Handle the error
		console.error("Upload error", error);
		return error;
	}

	uploadApkIpaFile({ tool_id, file }) {
		let requestParams: FormData = new FormData();
		requestParams.append("file", file, file.name);

		let requestConfig = {
			headers: new HttpHeaders({
				"Content-Type": "file",
				Accept: "file",
			}),
		};

		// Disable the global loading screen for file upload process
		this.loadingScreenService.disableLoadingForFileUpload();
		this.uploadInProgress$.next(true);

		return this.httpClient
			.post(
				`${environment.apiBaseUrl}/mobile-installer/upload`,
				requestParams,
				requestConfig
			)
			.pipe(
				catchError((error) => {
					// Handle error here
					this.uploadInProgress$.next(false);
					return this.handleError(error);
				}),
				finalize(() => {})
			);
	}
}
